<template>
  <div>
    <Header></Header>
    <main class="aml-page">
      <b-container>
        <section class="aml-card">
          <h1>{{ aml.title }}</h1>

          <h2>{{ aml.requirementsTitle }}</h2>
          <ul>
            <li v-for="(item, index) in aml.requirements" :key="`req-${index}`">{{ item }}</li>
          </ul>

          <p>{{ aml.sanctionsPolicy }}</p>
          <p>{{ aml.platformPolicy }}</p>
          <p>{{ aml.riskScoring }}</p>

          <h2>{{ aml.blockedTitle }}</h2>
          <ul class="aml-list">
            <li v-for="(item, index) in aml.blockedResources" :key="`blocked-${index}`">{{ item }}</li>
          </ul>

          <h2>{{ aml.highRiskTitle }}</h2>
          <p>{{ aml.highRiskLead }}</p>
          <ul>
            <li v-for="(item, index) in aml.highRiskCategories" :key="`risk-${index}`">{{ item }}</li>
          </ul>

          <p class="aml-note">{{ aml.note }}</p>
          <p>{{ aml.acceptance }}</p>
          <p>{{ aml.access }}</p>
          <p>{{ aml.updates }}</p>
        </section>
      </b-container>
    </main>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  },
  computed: {
    aml() {
      const localeMessages = this.$i18n.getLocaleMessage(this.$i18n.locale)
      return localeMessages.amlKyc || {}
    }
  }
}
</script>

<style lang="sass">
.aml-page
  padding: 32px 0

.aml-card
  background-color: #2f3338
  border-radius: 8px
  padding: 48px 40px
  box-shadow: 0 0 10px rgba(22, 22, 26, .5)

  h1
    margin-bottom: 1rem

  h2
    margin-top: 1.5rem
    margin-bottom: .75rem

  p
    margin-bottom: .75rem

  ul
    padding-left: 1.25rem
    margin-bottom: 1rem

.aml-list
  columns: 1

.aml-note
  font-style: italic

@media screen and (min-width: 992px)
  .aml-card
    padding: 64px 56px

    p
      margin-bottom: 1rem

    ul
      padding-left: 1.5rem
      margin-bottom: 1.25rem

  .aml-list
    columns: 2
</style>